"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lib_1 = require("@fuselab/ui-shared/lib");
var setiTheme_1 = require("./setiTheme");
function fileExtensionToIconIds(curTheme) {
    return {
        ts: curTheme.languageIds.typescript,
        tsx: curTheme.languageIds.typescriptreact,
        js: curTheme.languageIds.javascript,
        csproj: '_project',
        config: curTheme.languageIds.xml
    };
}
function fileExtensionToIcon(path, theme) {
    var ext = (lib_1.pathExt(path) || '').toLowerCase();
    var cur = theme === 'dark' ? setiTheme_1.SetiTheme : setiTheme_1.SetiTheme.light;
    var _default = theme === 'dark' ? '_default' : '_default_light';
    var fileExtensionIcons = fileExtensionToIconIds(cur);
    var iconId = cur.languageIds[ext] || cur.fileExtensions[ext] || fileExtensionIcons[ext] || _default;
    return setiTheme_1.SetiTheme.iconDefinitions[iconId];
}
exports.fileExtensionToIcon = fileExtensionToIcon;
function iconDefinitionToStyle(icon, theme) {
    var cur = theme === 'dark' ? setiTheme_1.SetiTheme : setiTheme_1.SetiTheme.light;
    return {
        color: icon.fontColor || setiTheme_1.SetiTheme.iconDefinitions[cur.file].fontColor,
        selectors: {
            '&:before': {
                fontFamily: 'seti',
                content: JSON.stringify(String.fromCharCode(parseInt(icon.fontCharacter.substr(1), 16))),
                fontSize: setiTheme_1.SetiTheme.fonts[0].size
            }
        }
    };
}
exports.iconDefinitionToStyle = iconDefinitionToStyle;
//# sourceMappingURL=fileIcons.js.map